import { Modal as ModalModule, UI } from 'common';
import isFunction from 'lodash/isFunction';
import uniq from 'lodash/uniq';
import React, { useState } from 'react';

const { Modal, ModalButtonActionType } = ModalModule;
const { WrappedDropdownWithLabel } = UI;

const ChangeCategoryModal = ({
	modalId,
	data: {
		label,
		categoryOptions = [],
		selectedProducts = [],
		onChangeCategoryCallback,
	},
}) => {
	const categories = selectedProducts
		.filter(({ CategoryId }) => CategoryId)
		.map(product => product.CategoryId);
	const uniqCategoryies = uniq(categories);
	const id = uniqCategoryies.length === 1 ? uniqCategoryies[0] : '';
	const [categoryId, setCategoryId] = useState(id);

	const onSaveCategory = closeModal => {
		if (isFunction(onChangeCategoryCallback)) {
			onChangeCategoryCallback(categoryId);
		}

		closeModal();
	};

	const onChangeCategory = ({ value }) => {
		setCategoryId(value);
	};

	const primaryButton = {
		type: ModalButtonActionType.Ok,
		text: 'Save',
		onClick: onSaveCategory,
		dataqa: 'change-category-save-button',
	};

	const secondaryButton = {
		type: ModalButtonActionType.Cancel,
		text: 'Cancel',
		dataqa: 'change-category-cancel-button',
	};

	return (
		<Modal
			modalId={modalId}
			className="products products-change-category-modal"
			header="Change Category"
			primaryButton={primaryButton}
			secondaryButton={secondaryButton}
			size="small"
		>
			<WrappedDropdownWithLabel
				label={label}
				uiElementConfig={{
					dataqa: 'change-category-dropdown',
					options: [...categoryOptions, { Name: 'None', CategoryID: '' }],
					optionLabel: 'Name',
					optionValue: 'CategoryID',
					value: categoryId,
					onChange: onChangeCategory,
				}}
			/>
		</Modal>
	);
};

export default ChangeCategoryModal;
